"use client";
import { ReactNode } from "react";

import { MobileMenuProvider } from "@lib/context/mobile-menu-context";

const Providers = ({ children }: { children: ReactNode }) => {
	return <MobileMenuProvider>{children}</MobileMenuProvider>;
};

export default Providers;
